import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import t from 'ember-intl/helpers/t';
import type { IntlService } from 'ember-intl';
import { Header, VStack } from 'tio-ui/components/layout';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import LoanPlansSection from 'tio-employee/components/strategy-finder-0726/loan-plans-section';
import { parseResultSections } from 'tio-employee/utils/strategy-finder-0726';

interface StrategyFinder0726ResultsTableSignature {
  Args: {
    recommendation: RecommendationModel;
  };
  Element: HTMLElement;
}

export default class StrategyFinder0726ResultsTableComponent extends Component<StrategyFinder0726ResultsTableSignature> {
  @service declare intl: IntlService;

  get sections() {
    return parseResultSections(
      this.args.recommendation.calculationInput,
      this.args.recommendation.calculationOutput
    );
  }

  // How the plans are ordered, derived from the borrower's payoff/afford answers
  // and uniform across loan types, shown next to the results heading.
  get sortLabel() {
    return this.sections[0]?.sortBy === 'total_then_first_month'
      ? this.intl.t('strategy_finder_0726.results.sorted_total_first')
      : this.intl.t('strategy_finder_0726.results.sorted_first_month_first');
  }

  <template>
    <VStack data-test-sf-0726-results ...attributes>
      <Header>
        {{t "strategy_finder_0726.results.title"}}
        {{#if this.sections.length}}
          <span class="tio-fg-secondary" data-test-sf-0726-results-sort>({{this.sortLabel}})</span>
        {{/if}}
      </Header>
      {{#if @recommendation.hasErrorsInCalcs}}
        <div class="m-2" data-test-sf-0726-results-error>
          {{t "strategy_finder_0726.results.error_in_calcs"}}
          <LinkTo @route="authenticated.strategy-finder-0726.questionnaire" class="tio-copy">
            {{t "strategy_finder_0726.results.error_link_text"}}
          </LinkTo>
        </div>
      {{else}}
        {{#each this.sections as |section|}}
          <LoanPlansSection @section={{section}} @analysisDate={{@recommendation.createdAt}} />
        {{/each}}
      {{/if}}
    </VStack>
  </template>
}
